module.exports = __webpack_public_path__ + "img/图层 14.3027a157.png";